import React, { useEffect, useState } from 'react'
import { Select } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { equals, map } from 'ramda'
import { useTranslation } from 'react-i18next'
import { fetchTypesOfBusiness } from '../../api'
import { usePresetValue, usePrevious } from '../../utils/hooks'
import { getUserValue } from '../utils'
import { EMPLOYMENT_ID } from '../../../constants/constants'

const ExternalBusinessTypes = ({ label, name, additionalInfo, showLabelAsPlaceholder }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [fldLabel, setFldLabel] = useState(t(`generatedField.${label}`))
  const [fetchError, setFetchError] = useState('')
  const [list, setList] = useState([])
  const [isValid, setIsValid] = useState(null)
  const [{ form, form: { accId }, user }, dispatch] = useStore()
  const { employmentSituationId } = form[accId]
  const userValue = getUserValue(accId, user, name)

  const prevLanguage = usePrevious(i18n.language)

  useEffect(() => {
    if (prevLanguage !== i18n.language || !list.length) {
      fetchTypesOfBusiness().then(
        /**
         * @param {Object[]} list
         */
        (list) => {
          const formattedList = map(
            ({ value, id }) => ({ value: id, label: value }),
            list
          )
          setList(formattedList)
        }, (error) => setFetchError(error.message))
    }
  }, [i18n.language, list])

  useEffect(() => {
    if (employmentSituationId === EMPLOYMENT_ID.UNEMPLOYED || employmentSituationId === EMPLOYMENT_ID.RETIRED) {
      setFldLabel(t(`generatedField.previous${label}`))
    } else {
      setFldLabel(t(`generatedField.${label}`))
    }
  }, [employmentSituationId, i18n.language])

  /**
   * @param {number} value
   */
  const presetValue = (value) => {
    const stringValue = value.toString()
    setValue(stringValue)
    const isValid = stringValue.length > 0
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value: value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  usePresetValue(name, userValue, presetValue)

  /**
   * @param {string} value
   */
  const getSelectValue = (value) => (equals(value, t('generatedField.choose')) ? '' : value)

  const onChange = ({ target: { value, name } }) => {
    const selectedValue = getSelectValue(value)
    setValue(selectedValue)
    setIsValid(selectedValue.length > 0)

    dispatch({ type: 'setExtFieldValue', name, value: +selectedValue })
    dispatch({ type: 'setValidationFld', name, value: selectedValue.length > 0 })
  }

  return (
    <>
      <Select
        value={value || ''}
        label={fldLabel}
        placeholder={t('generatedField.choose')}
        options={list}
        onChange={onChange}
        name={name}
        key={name}
        error=''
        valid={isValid}
        info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
        showLabelAsPlaceholder={showLabelAsPlaceholder}
      />
      {fetchError}
    </>
  )
}

const getExternalBusinessTypesFields = (businessTypeField) => {
  const { i18n, name, required, order } = businessTypeField
  return (
    <ExternalBusinessTypes
      label={i18n}
      name={name}
      required={required}
      key={name}
      order={order}
    />
  )
}

export { ExternalBusinessTypes, getExternalBusinessTypesFields }
